export default __webpack_public_path__ + "static/media/exterior-2.c733a620.webp";